<template>
    <div>
        <!-- <van-nav-bar title="下级持仓人数" left-text="" left-arrow @click-left="$router.push('/member/agency')" /> -->
        <div style="padding:10px">
            <van-row class="rowStyle" @click="openPop">
                <van-col span="12" class="rowLeftTxtStyle">
                    月份 &nbsp; <van-icon name="arrow-down" />
                </van-col>
                <van-col span="12" style="text-align: right;">
                    {{ selectedDate }}
                </van-col>
            </van-row>
            <van-row class="rowStyle">
                <van-col span="12">
                    每日持仓人数总和
                </van-col>
                <van-col span="12" style="text-align: right;">
                    {{ totalUsers }}
                </van-col>
            </van-row>
            <van-row class="rowStyle">
                <van-col span="12">
                    天数
                </van-col>
                <van-col span="12" style="text-align: right;">
                    {{ totalDays }}
                </van-col>
            </van-row>
            <van-row class="rowStyle">
                <van-col span="12">
                    日均持仓人数
                </van-col>
                <van-col span="12" style="text-align: right;">
                    {{ averageUsers }}
                </van-col>
            </van-row>
        </div>
        <!-- Bottom table data -->
        <van-list v-model="isLoading" @load="getAverageDepotPeople" :finished="finished" finished-text="没有更多了">
            <div class="table-title">
                <div>日期</div>
                <div>下一级持仓</div>
                <div>下二级持仓</div>
                <div>下三级持仓</div>
                <div>日小计</div>
            </div>
            <div class="table-content" v-for="(item, index) in dailyReport" :key="index">
                <div>{{ item.day }}</div>
                <div>{{ item.level1 }}</div>
                <div>{{ item.level2 }}</div>
                <div>{{ item.level3 }}</div>
                <div>{{ item.total }}</div>
            </div>
        </van-list>
        <van-popup v-model="calenderStatus" position="bottom" :close-on-click-overlay="true">
            <van-datetime-picker type="year-month" v-model="average_depot_month" @confirm="confirmDate"
                @cancel="calenderStatus = false" />
        </van-popup>
    </div>
</template>

<script>
export default {
    name: "LowerLeverDepot",
    data() {
        return {
            calenderStatus: false,
            isLoading: false,
            finished: false,
            page: 1,
            dailyReport: [],
            totalUsers: 0,
            totalDays: 0,
            averageUsers: 0,
            currentDate: '',
            minDate: '',
            maxDate: '',
            average_depot_month: '',
            columnsType: ['year', 'month'],
            selectedDate: '本月'
        }
    },
    components: {},
    methods: {
        openPop() {
            this.calenderStatus = true;
            this.average_depot_month = new Date();
        },
        confirmDate(date) {
            this.average_depot_month = Math.round(date.getTime() / 1000);
            var d = new Date(date.getTime());
            this.selectedDate = d.getFullYear() + ' / ' + (d.getMonth() + 1);
            this.calenderStatus = false;
            this.getAverageDepotPeople();
        },
        isLogin() {
            let that = this;
            if (!that.$store.state.loginType) {
                that.$router.push('/login')
            }
        },
        getAverageDepotPeople() {
            let that = this;
            that
                .$http({
                    url: "/",
                    method: "post",
                    data: {
                        nozzle: "agent_daily_depot",
                        token: sessionStorage.getItem("token"),
                        date: that.average_depot_month
                    }
                })
                .then(function (res) {
                    let resData = res.data;
                    that.isLoading = false;
                    that.finished = true;
                    if (res.data.code == 1) {
                        that.dailyReport = resData.data.data;
                        that.totalDays = resData.data.total_days;
                        that.totalUsers = resData.data.total_depot_users;
                        that.averageUsers = resData.data.avarage_depot_users;
                    } else if (res.data.code == 0) {
                        that.$toast.fail(res.data.msg);
                    }
                })
                .catch(() => {
                    that.isLoading = false;
                    that.finished = true;
                    that.$toast.fail(that.$NoNetworkErrorMsg)
                })
        },
    },
    mounted: function () {
        let that = this;
        that.isLogin();
    }
}
</script>

<style scoped>
.tableHeadding {
    text-align: center;
}

.table-content,
.table-title {
    width: 100%;
    overflow: hidden;
}

.table-title>div {
    width: 18%;
    float: left;
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
    background: #c8c9cc;
}

.table-content>div {
    width: 18%;
    float: left;
    padding: 10px 0;
    text-align: center;
    font-size: 12px;
}

.table-content>div:first-child {
    width: 28% !important;
}

.table-title>div:first-child {
    width: 28% !important;
}

.rowStyle {
    padding: 5px 0px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/LowerLeverDepot.vue